import axios from "axios";
import store from "../store";
const client = axios.create({
  baseURL: "https://api.birchequipment.com/",
  // baseURL: `http://35.236.93.48/api/Client`,
  json: true,
});
export default {
  async execute(method, resource, data) {
    return client({
      method,
      url: resource,
      data,
      headers: {
        APIKey: "C86714EE-9246-482F-BF08-00FC7EF4D4EA",
        accessToken: store.getters.smsAuthToken
          ? store.getters.smsAuthToken
          : null,
        // accessToken:"x+6UrfddnungxP4q/VSC9CIkEzAZn3VueYcsDjyTTd4=",
        // customerId: store.getters.companyIdDropdown == null ? "" : store.getters.companyIdDropdown
      },
    }).then((req) => {
      return req.data;
    });
  },
  //*History Report List
  getActivityList(typeOfSheet, typeUser, smsSheetId) {
    // let typeOfSheet,typeUser;
    // if(store.getters.companyNameDropdown != 'All' && store.getters.companyNameDropdown != "" && store.getters.companyNameDropdown != undefined){
    //   typeOfSheet = 'planningsheetsallhistorical';
    //   typeUser = 'customer';
    // }else{
    //   typeOfSheet = 'planningsheetshistorical';
    //   typeUser = 'customeruser';
    // }
    return this.execute("get", `${typeUser}/${smsSheetId}/${typeOfSheet}`);
  },
  //History delete
  deleteHistorySheetRecord(smsUserId, HistoryId) {
    return this.execute(
      "delete",
      `customeruser/${smsUserId}/planningsheets/${HistoryId}`
    );
  },
  // Current Sheets List
  getCurrentActivityList(typeOfSheet, typeUser, smsSheetId) {
    // let impersonatedCustomer = null;
    // console.log(store.getters.smsBirchLinkingId)
    // if(store.getters.companyIdDropdown == null || store.getters.smsBirchLinkingId == store.getters.smsCustomerId){
    //   alert('ok');
    //   impersonatedCustomer = null;
    //   console.log(impersonatedCustomer);
    // }else{
    //   impersonatedCustomer = store.getters.smsBirchLinkingId;
    // }
    // let typeOfSheet,typeUser;
    // console.log(store.getters)
    // if(!impersonatedCustomer){
    // // if(store.getters.companyNameDropdown != 'All' && store.getters.companyNameDropdown != "" && store.getters.companyNameDropdown != undefined){
    //   typeOfSheet = 'planningsheetsallcurrent';
    //   typeUser = 'customer';
    // }else{
    //   typeOfSheet = 'planningsheetsactive';
    //   typeUser = 'customeruser';
    // }
    return this.execute("get", `${typeUser}/${smsSheetId}/${typeOfSheet}`);
  },
  // Cuttent sheet delete
  deleteCurrentSheetRecord(smsUserId, planningSheetId) {
    return this.execute(
      "delete",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}`
    );
  },
  // Current Sheet submit
  submitProjectForreview(smsUserId, planningSheetId) {
    return this.execute(
      "put",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/submit`
    );
  },
  // get purchase login data
  getsmscustdata() {
    return this.execute(
      "get",
      "customeruser/login?username=andrear@birchequipment.com&password=Birch1415"
    );
  },
  // submit purchase
  submitPurchase(payload) {
    return this.execute("post", `birchequipment/purchaserequest`, payload);
  },
  //Create New Planning Sheet && driopdowns data
  getContactsList(smsUserId, smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/-1/users?status=AVAILABLE&customerID=${smsCustomerId}`
    );
  },
  getApproversList(smsUserId, smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/-1/approvers?status=AVAILABLE&customerID=${smsCustomerId}`
    );
  },
  getApproverProjects(smsUserId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/approver`
    );
  },
  getJobsiteList(companyId) {
    let linkingID;
    if (companyId != null) {
      linkingID = companyId;
    } else {
      linkingID = 0;
    }
    // return this.execute("get",`customer/%20%200000/jobsite`);
    return this.execute("get", `customer/${linkingID}/jobsite`);
  },
  //  post contact users
  postContactUsers(smsUserId, storeProjectionID, smsCustomerId, payload) {
    return this.execute(
      "post",
      `customeruser/${smsUserId}/planningsheets/${storeProjectionID}/users?customerID=${smsCustomerId}`,
      payload
    );
  },
  //  post approvers users
  postApprovers(smsUserId, storeProjectionID, smsCustomerId, payload) {
    return this.execute(
      "post",
      `customeruser/${smsUserId}/planningsheets/${storeProjectionID}/approvers?customerID=${smsCustomerId}`,
      payload
    );
  },
  //get current approvers
  getcurrentApprovers(smsUserId, storeProjectionID, smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/${storeProjectionID}/approvers?status=CURRENT&customerID=${smsCustomerId}`
    );
  },
  getavailableApprovers(smsUserId, storeProjectionID, smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/${storeProjectionID}/approvers?status=AVAILABLE&customerID=${smsCustomerId}`
    );
  },
  //Create New Planning Sheet related apis
  //Images List
  getItemsList() {
    // let smsUserId = store.getters.smsUserId;
    // Added static admin smsuserid in order to fetch all the items.
    let smsUserId = 159;
    console.log(smsUserId);
    return this.execute("get", `customeruser/${smsUserId}/item`);
  },
  getSuggest(itemKey) {
    return this.execute(
      "get",
      `/birchequipment/item/${itemKey}/suggesteditems`
    );
  },
  getSuggestedItemsById(smsUserId, storeProjectionID, storeprojectionItemId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/${storeProjectionID}/items/${storeprojectionItemId}`
    );
  },
  // saving api's
  createNewPlanningSheet(smsUserId, payload) {
    return this.execute(
      "post",
      `/customeruser/${smsUserId}/planningsheets`,
      payload
    );
  },
  editPlanningSheet(smsUserId, planningSheetId, payload) {
    return this.execute(
      "put",
      `/customeruser/${smsUserId}/planningsheets/${planningSheetId}`,
      payload
    );
  },
  copyProectionSheet(smsUserId, planningSheetId, payload) {
    return this.execute(
      "post",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/copy`,
      payload
    );
  },
  postReviewItemsList(smsUserId, planningSheetId, payload) {
    return this.execute(
      "post",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/items`,
      payload
    );
  },
  getReviewItemsList(smsUserId, planningSheetId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/items`
    );
  },
  // Review Table & Card data
  getReviewActivityList(smsUserId, planningSheetId) {
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}`
    );
  },
  refreshRates(smsUserId, planningSheetId) {
    return this.execute(
      "put",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/refreshrates`
    );
  },
  deleteReviewSheetRecord(smsUserId, planningSheetId, ItemId) {
    return this.execute(
      "delete",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/items/${ItemId}`
    );
  },
  // Review page submit
  finalSubmitOfItems(smsUserId, planningSheetId) {
    return this.execute(
      "put",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/submit`
    );
  },
  rejectItems(smsUserId, planningSheetId, reason) {
    return this.execute(
      "put",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/reject`,
      { RejectionReason: reason }
    );
  },
  //Customer rates dialog
  updateCustomRates(smsUserId, planningSheetId, planningSheetItemId, payload) {
    return this.execute(
      "put",
      `customeruser/${smsUserId}/planningsheets/${planningSheetId}/items/${planningSheetItemId}`,
      payload
    );
  },
  // --------------*-------------
  //SMS Alerts
  getEmailAlertsList(smsUserId) {
    return this.execute("get", `customeruser/${smsUserId}/emailalerts`);
  },
  postEmailAlertsList(smsUserId, payload) {
    return this.execute(
      "Post",
      `customeruser/${smsUserId}/emailalerts`,
      payload
    );
  },
  putEmailAlertsList(smsUserId, payload, BirchReportID) {
    return this.execute(
      "Put",
      `customeruser/${smsUserId}/emailalerts/${BirchReportID}`,
      payload
    );
  },
  getEmailReportsList() {
    return this.execute("get", `reports`);
  },
  deleteAlert(smsUserId, BirchReportID) {
    return this.execute(
      "delete",
      `customeruser/${smsUserId}/emailalerts/${BirchReportID}`
    );
  },
  // --------------------------------*-------------------------------
  // SMS Reports
  getActualCostReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%20%201702";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/actualcost?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getOffRentReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%20%201702";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/offrent?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getOffRentReportWithoutdates(smsUserId, smsCNum) {
    // let smsCNum = "%20%201702";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/offrent?custnum=${smsCNum}`
    );
  },
  getOnRentReport(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/onrent?custnum=${smsCNum}`
    );
  },
  getOnRentAnalysisReport(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/onrentcostanalysis?custnum=${smsCNum}`
    );
  },
  sendOnRentEmailToBirch(smsUserId, companyName, payload) {
    return this.execute(
      "Post",
      `customeruser/${smsUserId}/onrent?company=${companyName}`,
      payload
    );
  },
  getRentToDateReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/renttodateprojected?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getItemsRentedReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/itemsrented?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getSMSReservationReport(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/reservation?custnum=${smsCNum}`
    );
  },
  getHistoricalReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/historymaintenancerequests?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getHistoricalReportWithoutDates(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/historymaintenancerequests?custnum=${smsCNum}`
    );
  },
  getCustomerBalanceReport(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/customerbalance?custnum=${smsCNum}`
    );
  },
  getPlannedVsActualReport(smsUserId, customerId, planningSheetId) {
    // let customerId = "6";
    // https://api.birchequipment.com/customeruser/159/plannedvsactual?projectionid=1182&customerID=6
    return this.execute(
      "get",
      `customeruser/${smsUserId}/plannedvsactual?projectionid=${planningSheetId}&customerId=${customerId}`
    );
  },
  getPlannedVsActualReportDropdown(smsUserId, customerId) {
    // let customerId = "6";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/planningsheetsgetlocked?customerId=${customerId}`
    );
  },
  getActiveReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/activemaintenancerequests?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  getActiveReportWithoutDates(smsUserId, smsCNum) {
    // let smsCNum = "%2010872";
    return this.execute(
      "get",
      `customeruser/${smsUserId}/activemaintenancerequests?custnum=${smsCNum}`
    );
  },
  getServiceCallReport(smsUserId, smsCNum, fromDate, EndDate) {
    // let smsCNum = "%20%200000";
    return this.execute(
      "get",
      `customer/${smsUserId}/servicecall?custnum=${smsCNum}&startdate=${fromDate}&enddate=${EndDate}`
    );
  },
  //User Management
  getcustomer() {
    return this.execute("get", `customer`);
  },
  //User Management
  getUserPermissionsByBirchCustomerId(id) {
    return this.execute("get", `customer/${id}/users`);
  },
  // SMS User Type
  smsUserType() {
    return this.execute("get", `customer`);
  },
  smsBirchContacts() {
    return this.execute("get", `customeruser/birchcontacts`);
  },
  // usermanagement smsid based customers jobsite
  getJobsiteListUserPage(companyId) {
    console.log(companyId);
    let linkingID;
    if (companyId != null && companyId != "") {
      linkingID = companyId;

      return this.execute("get", `customer/${linkingID}/jobsite`);
    }
  },
  getAvailableJobNoRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/-1/availablejobnorestrictions?customerID=${smsCustomerId}`
    );
  },
  getAvailableOrderedByRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/-1/availableOrderedbyrestrictions?customerID=${smsCustomerId}`
    );
  },
  getAvailablePONoRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/-1/availablePONorestrictions?customerID=${smsCustomerId}`
    );
  },
  getAvailablePickedUpByRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `customeruser/-1/availablepickedupbyrestrictions?customerID=${smsCustomerId}`
    );
  },
};
